import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import context providers
import { AuthProvider } from './context/AuthContext';
import { ContentProvider } from './context/ContentContext';
import { BrowserRouter as Router } from 'react-router-dom'; // Use BrowserRouter here


// Create root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the application
root.render(
  // <React.StrictMode>
  <Router>
    <AuthProvider>
      <ContentProvider>
        <App />
      </ContentProvider>
    </AuthProvider>
  </Router>
  // </React.StrictMode>
);

// Optional: Measure app performance (e.g., for analytics)
reportWebVitals();
